import api from "./Api";

class RelatoriosModulosService {
  GetRelatoriosModulos(payload) {
    return api.get("/v1/relatoriosModulos/" + payload).then((response) => {
      return response.data;
    });
  }

  PostRelatoriosModulos(payload) {
    return api.post("/v1/relatoriosModulos/", payload).then((response) => {
      return response.data;
    });
  }

  PutRelatoriosModulos(payload) {
    return api.put("/v1/relatoriosModulos/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteRelatoriosModulos(payload) {
    return api.delete("/v1/relatoriosModulos/" + payload).then((response) => {
      return response.data;
    });
  }

  GetRelatoriosModulosOData(payload) {
    return api.get("/OData/RelatoriosModulos" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new RelatoriosModulosService();
